import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class ButtonToggleLanguageOverlay {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.languageSelect;
        };
    }
    componentDidLoad() {
        this.open = AppState.languageSelect;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    onClick() {
        AppState.toggleLanguageSelect();
        this.open = AppState.languageSelect;
    }
    render() {
        return (h(Host, { key: '99767577403b42de8e3c8b499273ae594cc1545c', role: "button", class: {
                'btn-icon': true,
                'active': this.open
            } }, h("svg", { key: '88daeaa4f4386ed33bf1df1f038c9e94a5b36ba8', xmlns: "http://www.w3.org/2000/svg", width: "24", height: "25" }, h("use", { key: '4e1cddaa1fc3313984410409d21c2db69ad49b30', href: "#globe" }))));
    }
    static get is() { return "uvex-button-toggle-language-overlay"; }
    static get states() {
        return {
            "open": {}
        };
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=button-toggle-language-overlay.js.map
